<template>
  <div id="region-chart">
    <div class="chart-info-container">
      <Pie
        :id="watershedId"
        :variable="variable"
        :range="range"
        classCol="type"
        valueCol="total"
        v-if="chartType === 'pie'"
        class="chart-col"
      />
      <Bar
        :id="watershedId"
        :variable="variable"
        :range="range"
        classCol="type"
        valueCol="total"
        v-if="chartType === 'bar'"
      />
    </div>
    <div class="chart-selector">
      <label>
        <input type="radio" name="chart-type" value="pie" v-model="chartType" /> Porcentajes
      </label>&nbsp;
      <label>
        <input type="radio" name="chart-type" value="bar" v-model="chartType" /> Totales
      </label>
    </div>
  </div>
</template>

<script>
import Pie from '@/components/Pie.vue';
import Bar from '@/components/Bar.vue';
import { LAYER_INCENDIOS } from '@/settings';

export default {
  name: 'RegionChart',

  components: {
    Pie,
    Bar,
  },

  props: {
    watershedId: {
      required: true,
    },

    variable: {
      required: true,
    },

    range: {
      required: true,
    },
  },

  data() {
    return {
      chartType: 'pie',
    };
  },

  watch: {
    variable() {
      if (this.variable === LAYER_INCENDIOS) {
        this.chartType = 'bar';
      } else {
        this.chartType = 'pie';
      }
    },
  },
};
</script>

<style lang="scss" scoped>
@import '../styles/variables.scss';

#region-chart {
  display: grid;
  grid-template-rows: auto 30px;
  background-color: $color-clear;
  border-radius: $border-radius;

  .chart-info-container {
      position: relative;

      #pie-chart, #bar-chart {
        height: 100%;
        contain: size;
      }
  }

  .chart-selector {
    text-align: center;
  }
}
</style>
